<div class="jumbotron text-center">
  <h2 class="display-4"></h2>
  <br>
  <mat-card class="bienvenida-card" *ngIf="!disclaimerVoto && !mostrarSeleccionVotantes">
    <mat-card-header>
      <mat-card-title> Bienvenido/Bienvenida a la {{ datosAsamblea.descripcionAsamblea }} </mat-card-title>
      <mat-card-subtitle *ngIf="!edicionVoto">¡Gracias por registrar su asistencia!</mat-card-subtitle>
      <mat-card-subtitle *ngIf="edicionVoto">¡Edita tu voto de manera rápida y sencilla.!</mat-card-subtitle>
    </mat-card-header>



    <mat-card-content>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" type="button" (click)="ingresarAsamblea()" [disabled]="deshabilitarBtn" *ngIf="!edicionVoto">
        Continuar
      </button>
      <button mat-raised-button color="primary" type="button" (click)="ingresarAsamblea()" [disabled]="deshabilitarBtn" *ngIf="edicionVoto">
        Editar
      </button>
    </mat-card-actions>
  </mat-card>


  <mat-card class="bienvenida-card" *ngIf="disclaimerVoto && !mostrarSeleccionVotantes">
    <mat-card-header>
      <mat-card-title>Importante: Con el voto registrado de manera anticipada se considerará su participación a efectos de determinar el quórum para la instalación de la asamblea. Asimismo, tener en cuenta que su voto anticipado para la primera convocatoria también será considerado para la segunda en caso de declararse desierta la primera.</mat-card-title>
      <mat-card-title>El voto anticipado podrá ser modificado sólo durante el periodo de votación anticipada.</mat-card-title>
      <mat-card-subtitle >Para mayor información, por favor, revisar el “Documento Informativo para la celebración de la asamblea” adjunto en la citación de la convocatoria.</mat-card-subtitle>      
    </mat-card-header>    
    <mat-card-content>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" type="button" (click)="ingresarAsamblea()" >
        Entendido
      </button>
    </mat-card-actions>
  </mat-card>






    <div *ngIf="mostrarSeleccionVotantes" class="seleccion-container">
    <mat-card class="seleccion-card">
      <mat-card-header>
        <mat-card-title>
          <mat-icon>group</mat-icon>
          Selección de Votante
        </mat-card-title>
        <mat-card-subtitle>
          ¡Hola! Hemos detectado que eres representante de otro(s) partícipe(s):
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <!-- Voto Propio -->
        <div *ngIf="votantesPropios.length > 0" class="seccion-voto">
          <h3 class="subtitulo">Voto Propio:</h3>
          <mat-list class="lista-votantes">
            <mat-list-item *ngFor="let votante of votantesPropios" 
                          [class.deshabilitado]="votante.yaVoto || votante.puedeVotar==false"
                          (click)="!votante.yaVoto && votante.puedeVotar==true && seleccionarVotante(votante)">
              <div mat-line class="info-votante">
                <span class="dni"> {{ dataStore.asistente.tipoDocumento + ' ' + votante.dni }}</span>
                <span class="nombre">{{ votante.nombre }}</span>
              </div>
              
              <div class="accion-voto">
                <!-- Radio button circular -->
                <mat-radio-button [checked]="votanteSeleccionado?.dni === votante.dni"
                                 [disabled]="votante.yaVoto || votante.puedeVotar==false"
                                 (change)="!votante.yaVoto && votante.puedeVotar==true && seleccionarVotante(votante)">
                </mat-radio-button>
                
                <span class="estado-voto" [class.ya-voto]="votante.yaVoto">
                  {{ votante.yaVoto ?  '✓ Ya votó' : ( votante.puedeVotar==false ? 'No puede votar' : 'Pendiente') }}
                </span>
              </div>
            </mat-list-item>
          </mat-list>
        </div>

        <!-- Voto Delegado -->
        <div *ngIf="votantesDelegados.length > 0" class="seccion-voto">
          <h3 class="subtitulo">Voto Delegado:</h3>
          <mat-list class="lista-votantes">
            <mat-list-item *ngFor="let votante of votantesDelegados" 
                          [class.deshabilitado]="votante.yaVoto"
                          (click)="!votante.yaVoto && seleccionarVotante(votante)">
              <div mat-line class="info-votante">
                <span class="dni">{{ votante.dni }}</span>
                <span class="nombre">{{ votante.nombre }}</span>
              </div>
              
              <div class="accion-voto">
                <mat-radio-button [checked]="votanteSeleccionado?.dni === votante.dni"
                                 [disabled]="votante.yaVoto"
                                 (change)="!votante.yaVoto && seleccionarVotante(votante)">
                </mat-radio-button>
                
                <span class="estado-voto" [class.ya-voto]="votante.yaVoto">
                  {{ votante.yaVoto ? '✓ Ya votó' : 'Pendiente' }}
                </span>
              </div>
            </mat-list-item>
          </mat-list>
        </div>

        <!-- Si solo hay un votante (no es representante) -->
        <div *ngIf="!esRepresentante && votanteUnico" class="votante-unico">
          <mat-card class="simple-card">
            <mat-card-content>
              <div class="votante-info">
                <mat-icon>person</mat-icon>
                <div>
                  <h4>{{ votanteUnico.nombre }}</h4>
                  <p>DNI: {{ votanteUnico.dni }}</p>
                  <p *ngIf="votanteUnico.yaVoto" class="text-warning">
                    <mat-icon>warning</mat-icon> Ya has votado
                  </p>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </mat-card-content>

      <mat-card-actions class="acciones-seleccion">
        <button mat-button color="warn" (click)="regresar()">
          <mat-icon>arrow_back</mat-icon>
          Regresar
        </button>
        
        <button mat-raised-button color="primary" 
                [disabled]="!votanteSeleccionado || (votanteSeleccionado && votanteSeleccionado.yaVoto)"
                (click)="irAVotacion()">
          <mat-icon>how_to_vote</mat-icon>
          {{ votanteSeleccionado ? 'Votar por ' + votanteSeleccionado.nombre : 'Seleccionar votante' }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>









</div>
